<template>
  <BaseTableView :head="tableHead">
    <EmployeesGroupListItem v-for="(item, key) in items" :key="key" :item="item" />
  </BaseTableView>
</template>

<script>
import EmployeesGroupListItem from 'components/employees/group/EmployeesGroupListItem'

export default {
  name: 'EmployeesTable',
  props: ['items'],
  components: {
    EmployeesGroupListItem,
  },
  data: () => ({
    dialog: false,
    search: '',
  }),
  computed: {
    tableHead() {
      return [
        {
          text: this.localStorage.translations.pages.personnel_department['employees-group_tables'][
            'nazvanie-podrazdeleniya'
          ],
          sort: {
            name: 'name',
            value:
              this.$route.query.sort_param && this.$route.query.sort_param === 'name'
                ? this.$route.query.sort_value && this.$route.query.sort_value === 'desc'
                  ? 'asc'
                  : 'desc'
                : 'asc',
          },
        },
        {
          text: this.localStorage.translations.pages.personnel_department['employees-group_tables'][
            'ctatusy-sotrudnikov'
          ],
        },
        {
          text: '',
          active: true,
        },
      ]
    },
  },
}
</script>

<style lang="scss" scoped>
:deep()td {
  &:nth-child(1) {
    width: 30%;
  }
  &:nth-child(2) {
    width: auto;
  }
  &:nth-child(3) {
    width: 140px;
  }
}
</style>
